module.exports = __webpack_public_path__ + "media/images/emblems/Malters_LU-212f0097dd59bac78a2eb7dfb09e59ac.png";